import { render } from "./PrimeiroNome.vue?vue&type=template&id=49cc5cdf"
import script from "./PrimeiroNome.vue?vue&type=script&lang=js"
export * from "./PrimeiroNome.vue?vue&type=script&lang=js"
script.render = render

export default script